// consistent box shadows
export const shadows = {
  outer: {
    none: `unset`,
    light: `0px 0px 4px 0px rgba(0, 0, 0, 0.1)`, // custom
    lightLong: `0px 0px 4px 0px rgba(0, 0, 0, 0.1), 0px 20px 50px -15px rgba(0, 0, 0, 0.3)`, // custom
    // lightHover: `0px 0px 20px 0px rgba(0, 0, 0, 0.1)`,
    medium: `0px 0px 8px 1px rgba(0, 0, 0, 0.1)`, // 10-8-1
    mediumLong: `0px 0px 2px 0px rgba(0, 0, 0, 0.25), 0px 20px 30px -15px rgba(0, 0, 0, 0.3)`, // custom
    bottomLong: `0px 9px 15px 2px rgba(0, 0, 0, 0.09)`, // better
    onlyBottomLong: `0px 15px 15px 0px rgba(0, 0, 0, 0.09)`,
    topLong: `0px -9px 15px 2px rgba(0, 0, 0, 0.09)`, // better
    sharpLight: `0px 0px 3px 0px rgba(0, 0, 0, 0.3)`,
    bottom: `0px 5px 10px 0px rgba(0, 0, 0, 0.15)`,
  },
  inner: {
    none: `unset`,
    lightSharp: `inset 0px 0px 5px -1px rgba(0, 0, 0, 0.3)`,
    medium: `inset 0px 0px 12px 0px rgba(0, 0, 0, 0.2)`,
    mediumVertical: `inset 0px 10px 12px -10px rgba(0, 0, 0, 0.2), inset 0px -10px 12px -10px rgba(0, 0, 0, 0.2)`,
  },
} as const

// consistent text shadows
export const textShadows = {
  none: `unset`,
  medium: `0 2px 5px rgba(0, 0, 0, 0.6)`,
} as const

// key of outer box shadows – use for prop specifying outer shadow
export type TOuterShadow = keyof typeof shadows.outer
// key of inner box shadows – use for prop specifying inner shadow
export type TInnerShadow = keyof typeof shadows.inner
// key of text shadows – use for prop specifying text shadow
export type TTextShadow = keyof typeof textShadows
